import React from "react";
import { ButtonBase } from "@mui/material";

const NavLogo = ({ size = 60 }) => {
  return (
    <ButtonBase
      disableRipple
      // onClick={() => openInNewTab("https://www.ongil.ai/")}
    >
      <img src={"/static/img/asia-pacific-2x.png"} alt={"Asiapacific"} style={{ height: `${size}px` }} />
    </ButtonBase>
  );
};

export default NavLogo;
